export const getDepositStatus = (state) => state.depositStatus
export const getDeposits = (state) => state.deposits.data
export const getDepositsMeta = (state) => state.deposits.meta